let saveToken = (token) => {
    sessionStorage.setItem('token', token);
}

let logout = (token) => {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
}

let isAuthenticated = () => {
    let token = sessionStorage.getItem('accessToken');

    return !!token;

}
let UsernameAuthenticated = () => {

    let token = sessionStorage.getItem('accessToken');
    return token;
}

let parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const accountService = {
    saveToken,
    logout,
    isAuthenticated,
    UsernameAuthenticated,
    parseJwt
}